import { notification } from 'antd';

export interface ImportWarningsResponse {
    warnings?: string[];
}

export function showImportWarnings(response?: ImportWarningsResponse) {
    response?.warnings
        ?.filter(warning => warning.trim())
        .forEach(description => {
            notification.warning({ message: 'Imported classifications need review', description, duration: 0 });
        });
}
